import {getSaltySets, SaltySet} from "@/data/saltyCards";

const DAY_IN_MS = 24 * 60 * 60 * 1000

// Day 0 of salt mode. Puzzles roll over at 4am UTC, same as the rest of spellify.
// Month is 0-indexed, so 9 is October
export const SALT_START_DATE = new Date(Date.UTC(2026, 9, 5, 4, 0, 0))

// Salt voting runs Oct 5-9, so salt mode ends when the Oct 10 puzzle rolls over.
// Once this passes every salt link is hidden and the salt page shows a goodbye message
export const SALT_END_DATE = new Date(Date.UTC(2026, 9, 9, 4, 0, 0))

export const isSaltOver = (now: Date = new Date()): boolean => now.getTime() >= SALT_END_DATE.getTime()

// How many days it has been since salt started, 0 on the first day
export const getSaltDay = (now: Date = new Date()): number =>
  Math.max(0, Math.floor((now.getTime() - SALT_START_DATE.getTime()) / DAY_IN_MS))

// The puzzle number we show the player, #1 on the first day
export const getSaltNumber = (now: Date = new Date()): number => getSaltDay(now) + 1

// The five cards for the day. There are five sets, so they cycle every five days.
export const getSaltSetForDay = (now: Date = new Date()): SaltySet => {
  const sets = getSaltySets()
  return sets[getSaltDay(now) % sets.length]
}
